// Pure, dependency-free "Ship From" country data + search filter. Kept
// outside components/ShipFromFilter.js (same pattern as categorySearch.js)
// so it can be unit-tested with plain node:test without pulling in React.
// Single source of truth for both the quick bar and the modal grid -- no
// country list duplicated in two places.

// Flag rendered as a Unicode emoji (regional indicator pair) -- no flag
// image asset or library exists in this project, and storing flag
// images/Buffers in the DB is out of scope for a simple UI filter.
const countryFlagEmoji = (code) => {
  const normalized = String(code || "").trim().toUpperCase();
  if (!/^[A-Z]{2}$/.test(normalized)) return "";
  const codePoints = [...normalized].map((char) => 127397 + char.charCodeAt(0));
  return String.fromCodePoint(...codePoints);
};

// Superset shown in the "Ship From" modal. The quick bar (SHIP_FROM_QUICK_COUNTRIES
// below) only surfaces a subset of these -- both read from this single array,
// so a country is never listed/spelled out twice.
const SHIP_FROM_COUNTRIES = [
  { code: "AU", name: "Australia" },
  { code: "CA", name: "Canada" },
  { code: "CN", name: "China" },
  { code: "FR", name: "France" },
  { code: "DE", name: "Germany" },
  { code: "ID", name: "Indonesia" },
  { code: "JP", name: "Japan" },
  { code: "MY", name: "Malaysia" },
  { code: "MX", name: "Mexico" },
  { code: "NG", name: "Nigeria" },
  { code: "PH", name: "Philippines" },
  { code: "RO", name: "Romania" },
  { code: "ES", name: "Spain" },
  { code: "TH", name: "Thailand" },
  { code: "AE", name: "United Arab Emirates" },
  { code: "GB", name: "United Kingdom" },
  { code: "US", name: "United States" },
].map((country) => ({ ...country, flag: countryFlagEmoji(country.code) }));

// Order shown in the horizontal bar above the product grid (after "All").
const SHIP_FROM_QUICK_CODES = ["US", "CN", "GB", "DE", "CA", "FR"];
const SHIP_FROM_QUICK_COUNTRIES = SHIP_FROM_QUICK_CODES
  .map((code) => SHIP_FROM_COUNTRIES.find((country) => country.code === code))
  .filter(Boolean);

const normalizeSearchText = (value) => String(value || "").toLowerCase();

// Local filter for the modal's search field -- name or ISO code, partial,
// case-insensitive. Never triggers a CJ API request per keystroke (there is
// nothing to fetch: this list is static).
const filterShipFromCountries = (countries, query) => {
  const q = normalizeSearchText(query).trim();
  if (!q) return countries;
  return countries.filter((country) =>
    normalizeSearchText(country.name).includes(q) || normalizeSearchText(country.code).includes(q));
};

module.exports = {
  SHIP_FROM_COUNTRIES,
  SHIP_FROM_QUICK_COUNTRIES,
  countryFlagEmoji,
  filterShipFromCountries,
};
